import { useEffect, useState } from "react";

import { ArrowButton, Button } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { getEnrollmentConditionById } from "../../api/nisooApi";
import StaticField from "../../components/StaticField";
import { EnrollmentCondition } from "../../models/EnrollmentCondition";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { codebookRouteEnrollmentCondition } from "../../routes/routes";
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookEnrollmentConditionDetails(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { data: userSession } = useGetUserSessionQuery();

  const [enrollmentCondition, setEnrollmentCondition] = useState<EnrollmentCondition>();
  const userCanEditData = userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager 
    || userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.Helpdesk);

  useEffect(() => {
    if (!location || !location.state || !(location.state as any).enrollmentConditionId) {
      return
    }
    const getEnrollmentCondition = async () => {
      var result = await getEnrollmentConditionById((location.state as any).enrollmentConditionId);
      setEnrollmentCondition(result);
    }
    getEnrollmentCondition();
  }, [location]);

  const navigateToEdit = (item: EnrollmentCondition) => {
    history.push(
      codebookRouteEnrollmentCondition(),
      {
        page: "edit",
        enrollmentConditionId: item.id
      }
    );
  }

  const navigateToList = () => {
    history.push(
      codebookRouteEnrollmentCondition(),
      {
        page: "list"
      }
    );
  }

  return (
    <>
      {enrollmentCondition &&
        <>
          <Row>
            <Col md={9}>
              <ArrowButton backwards ariaLabel="" onClick={navigateToList} />
              <span className={styles.backButtonCaption}>
                {t("codeBook.returnToList")}
              </span>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={8}>
              <h3>{t("codeBook.enrollmentCondition")}</h3>
            </Col>
            {userCanEditData &&
              <Col md={4} className="d-flex justify-content-end align-items-center">
                <Button onClick={() => navigateToEdit(enrollmentCondition)}>
                  {t("common.edit")}
                </Button>
              </Col>
            }
          </Row>
          <Row className="mt-5">
            <Col md={4} >
              <StaticField
                label={t("common.name")}
                value={enrollmentCondition.name}
              />
            </Col>
            <Col md={4} >
              <StaticField
                label={t("common.dateTo")}
                value={enrollmentCondition.dateTo ? hrDate(enrollmentCondition.dateTo) : ""}
              />
            </Col>
          </Row>
        </>
      }
    </>
  );
}